import { SideNav } from "@/components/shell/SideNav";
import { Outlet } from "react-router-dom";

export function EnterpriseLayout() {
  return (
    <div className="flex min-h-screen w-full">
      <SideNav zone="enterprise" />
      <main className="flex-1 overflow-y-auto bg-muted/20 p-6">
        <div className="mx-auto max-w-6xl">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
